export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ20.429b98b2.mp3";